import React from 'react';
import { CCard, CCardBody, CContainer, CRow, CCol } from '@coreui/react';
import noNotificationsPlaceholder from '../../icons/tabler-icon-message-circle-question.svg';
import _t from 'counterpart';

const NoNotificationsPlaceholder = () => {
  return (
    <CContainer
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ height: '100%', paddingTop: '2rem' }}
    >
      <CRow className="justify-content-center">
        <CCol>
          <CCard className="border-0 shadow-none text-center">
            <CCardBody>
              <div className="mb-4">
                <img
                  src={noNotificationsPlaceholder}
                  alt={_t.translate('notifications.no-notifications')}
                  style={{ width: 'auto', height: '66px' }}
                  className="mb-3"
                />
              </div>
              <div style={{ margin: '0 auto' }}>
                <p className="text-muted mb-1" style={{ fontSize: '1rem' }}>
                  {_t.translate('notifications.no-notifications-title')}
                </p>
                <p className="fw-bold" style={{ fontSize: '1.1rem' }}>
                  {_t.translate('notifications.no-notifications-p1')} <br />
                  {_t.translate('notifications.no-notifications-p2')}
                </p>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default NoNotificationsPlaceholder;
